export default "__VITE_ASSET__CAExg88h__"